export enum PalletStatus {
    Undetermined = -1,
    LabelPrinting = 0,
    LabelPrinted = 1,
    LabelPrintedNiu = 2,
    CusIncubation = 3,
    Good = 4,
    BlockedResort = 5,
    Resorted = 6,
    Scrap = 7,
    TestPallet = 8,
    CustomerReturn = 9,
    BlockedQi = 10,
    Saleablerestricted = 11,
    BlockedPackaging = 12,
    Issued = 13,
    Consumed = 14,
    Returned = 15,
    StockReceived = 16,
    Good2 = 17,
    Deleted = 18,
    Repacking = 19,
    Loaded = 20,
    Shipped = 21,
    ScrapWarehouse = 22,
    Wip = 90
}
